import {DescriptorEnum} from "./descriptor.enum";
import {ConfigStructure} from "../config-structure.model";

export class DescriptorConfig {

  personal_descriptorConfig: ConfigStructure[] = [];

  corporate_descriptorConfig: ConfigStructure[] = [];

  event_descriptorConfig: ConfigStructure[] = [];

  geographical_descriptorConfig: ConfigStructure[] = [];

  subject_descriptorConfig: ConfigStructure[] = [];

  genre_descriptorConfig: ConfigStructure[] = [];

  getDescriptorConfig(type: DescriptorEnum): ConfigStructure[] {
    return this[`${type}Config`];
  }

  setDescriptorConfig(type: DescriptorEnum, config: ConfigStructure[]): void {
    this[`${type}Config`] = config;
  }
}
